// Function to update the cart
export const update_cart = (cart) => {
    if (typeof window !== 'undefined' && window.localStorage) {
        try {
            // Update the cart by storing the new cart data
            localStorage.setItem('cart', JSON.stringify(cart));
            return true;
        } catch (error) {
            console.error('Error updating cart:', error);
            return false;
        }
    } else {
        console.warn('localStorage is not available');
        return false;
    }
};

// Function to fetch the cart
export const fetch_cart = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
        try {
            const cartData = localStorage.getItem('cart');
            // Return parsed cart if exists, otherwise return null
            return cartData ? JSON.parse(cartData) : null;
        } catch (error) {
            console.error('Error fetching cart:', error);
            return null;
        }
    }
    return null;
};